<template>
  <div class="container-f2g black-container login-container">
    <div class="f2g-wind-container">
      <div class="row">
        <div class="col-md-6">
          <div class="login-form">
            <div class="master-title-login">
              {{ words["myf2g.login.title"] }}
            </div>
            <div class="select-bundles">
              <router-link
                :to="{ name: 'MobileForm' }"
                tag="div"
                active-class="active-selected-category"
                class="selected-category"
              >
                {{ words["myf2g.login.option.mobile"] }}
              </router-link>

              <router-link
                :to="{ name: 'CredentialsForm' }"
                tag="div"
                active-class="active-selected-category"
                class="selected-category"
              >
                {{ words["myf2g.login.option.credentials"] }}
              </router-link>
            </div>
            <router-view />
            <p class="recaptcha-disclaimer">
              This site is protected by reCAPTCHA <br />
              and the Google
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and
              <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </p>
          </div>
        </div>
        <div class="col-md-6"></div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store/store";

export default {
  name: "LoginOptions",
  data: function () {
    return {
      words: {},
    };
  },
  computed: {
    locale() {
      return store.state.locale;
    },
    loginWords() {
      return store.state.loginWords;
    },
  },
  beforeMount() {
    if (sessionStorage.getItem("wcs_myf2glogin_" + this.locale) != null) {
      this.words = JSON.parse(sessionStorage.getItem("wcs_myf2glogin_" + this.locale));
    } else {
      let config = {
        method: "get",
        url: "/gr/f2g/vueContentService/",
        params: {
          ciKey: "myf2glogin",
          locale: this.locale,
        },
      };

      let self = this;
      this.axios(config)
        .then(function (response) {
          console.log(response);
          self.words = response.data;
          sessionStorage.setItem(
            "wcs_myf2glogin_" + self.locale,
            JSON.stringify(self.words)
          );
        })
        .catch(function (error) {
          console.error(error);
        });
    }
  },
};
</script>

<style>
.grecaptcha-badge {
  display: none;
}

p.recaptcha-disclaimer {
  font-family: Manrope-Normal;
  color: #ada8a0;
  font-size: 1.4rem;
  line-height: 1.9rem;
  margin: 50px 0;
  text-align: center;
}

p.recaptcha-disclaimer a {
  color: #ada8a0;
  text-decoration: underline;
}
</style>
